import { ROUTES } from ".";

export const MANAGE_RKAAS_ROUTES = {
  INVESTMENT: `${ROUTES.RKAAS}/manage-investment`,
  ADD_INVESTMENT: `${ROUTES.RKAAS}/add-investment`,
  CUSTODIAN: `${ROUTES.RKAAS}/manage-custodian`,
  ADD_CUSTODIAN: `${ROUTES.RKAAS}/add-custodian`,
  CUSTODIAN_DETAIL: `${ROUTES.RKAAS}/custodian-detail`,
  RKAS: `${ROUTES.RKAAS}/rkas`,
  TRIAL_BALANCE: `${ROUTES.RKAAS}/trial-balance`,
  LEDGERS: `${ROUTES.RKAAS}/ledgers`,
  REPORTS: `${ROUTES.RKAAS}/reports`,
  CUSTOM_REPORTS: `${ROUTES.RKAAS}/custom-reports`,
};

export const REVIEW_SCREEN_DATA_MAPPING = {
  INVESTMENT: "investment",
  CUSTODIAN: "custodian",
  RKAS: "rkas",
  TRIAL_BALANCE: "trail-balance",
  LEDGERS: "ledgers",
  REPORTS: "reports",
  CUSTOM_REPORTS: "custom-reports",
};

export const MANAGE_RKAAS_MENU = [
  {
    id: REVIEW_SCREEN_DATA_MAPPING.INVESTMENT,
    label: "Investment",
    path: MANAGE_RKAAS_ROUTES.INVESTMENT,
    contentHeader: "Investment",
    breadCrumbs: [],
    childRoutes: [MANAGE_RKAAS_ROUTES.ADD_INVESTMENT],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.CUSTODIAN,
    label: "Custodian",
    path: MANAGE_RKAAS_ROUTES.CUSTODIAN,
    contentHeader: "Custodian",
    breadCrumbs: [],
    childRoutes: [
      MANAGE_RKAAS_ROUTES.ADD_CUSTODIAN,
      MANAGE_RKAAS_ROUTES.CUSTODIAN_DETAIL,
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.RKAS,
    label: "Balance Sheet",
    path: MANAGE_RKAAS_ROUTES.RKAS,
    contentHeader: "RKAS",
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.TRIAL_BALANCE,
    label: "Trial Balance",
    path: MANAGE_RKAAS_ROUTES.TRIAL_BALANCE,
    contentHeader: "Trial Balance",
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.LEDGERS,
    label: "Ledgers",
    path: MANAGE_RKAAS_ROUTES.LEDGERS,
    contentHeader: "Ledgers",
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.REPORTS,
    label: "Reports",
    path: MANAGE_RKAAS_ROUTES.REPORTS,
    contentHeader: "Reports",
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.CUSTOM_REPORTS,
    label: "Custom Reports",
    path: MANAGE_RKAAS_ROUTES.CUSTOM_REPORTS,
    contentHeader: "Custom Reports",
    breadCrumbs: [],
    childRoutes: [],
  },
];

export const ALL_MANAGE_RKAAS_ROUTES = [
  ...MANAGE_RKAAS_MENU,
  {
    id: REVIEW_SCREEN_DATA_MAPPING.INVESTMENT,
    contentHeader: "Investment",
    path: MANAGE_RKAAS_ROUTES.ADD_INVESTMENT,
    breadCrumbs: [
      {
        label: "Manage Investments",
        link: MANAGE_RKAAS_ROUTES.INVESTMENT,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.CUSTODIAN,
    contentHeader: "Custodian",
    path: MANAGE_RKAAS_ROUTES.ADD_CUSTODIAN,
    breadCrumbs: [
      {
        label: "Manage Custodians",
        link: MANAGE_RKAAS_ROUTES.CUSTODIAN,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.CUSTODIAN,
    contentHeader: "Custodian",
    path: MANAGE_RKAAS_ROUTES.CUSTODIAN_DETAIL,
    breadCrumbs: [
      {
        label: "Manage Custodians",
        link: MANAGE_RKAAS_ROUTES.CUSTODIAN,
      },
    ],
  },
];

export const manageRkaasFormNames = {
  INVESTMENT_FILTER: "Investment_filter",
  ADD_INVESTMENT: "Add_Investment",
  ADD_CUSTODIAN: "Add_Custodian",
  ADD_CUSTOMREPORTS: "Add_Custom_Reports",
};

export const rkaasFormFields = {
  [manageRkaasFormNames.ADD_CUSTOMREPORTS]: {
    accountType: "accountType",
    accountName: "accountName",
    employee: "employee",
    investment: "investment",
    source: "source",
  },
  [manageRkaasFormNames.INVESTMENT_FILTER]: {
    search: "search",
    investmentType: "investmentType",
    investmentStatus: "investmentStatus",
  },
  [manageRkaasFormNames.ADD_INVESTMENT]: {
    investmentId: "investmentId",
    includeInvestmentIn: "includeInvestmentIn",
    companyId: "companyId",
    type: "type",
    investmentCategory: "investmentCategory",
    accountType: "accountType",
    name: "name",
    description: "description",
    status: "status",
    suspendedFromDate: "suspendedFromDate",
    suspendedToDate: "suspendedToDate",
    inceptionDate: "inceptionDate",
    fundCode: "fundCode",
    fundFamily: "fundFamily",
    cusip: "cusip",
    sedol: "sedol",
    isin: "isin",
    ticker: "ticker",
    shareClass: "shareClass",
    typeOfEarnings: "typeOfEarnings",
    isInvestmentQDIA: "isInvestmentQDIA",
    volatility: "volatility",
    prospectusDeliveryMethod: "prospectusDeliveryMethod",
    frequencyOfProspectusDisclaimer: "frequencyOfProspectusDisclaimer",
    isEquityWashRuleApplicable: "isEquityWashRuleApplicable",
    competingFunds: "competingFunds",
    restrictedPeriod: "restrictedPeriod",
    restrictedPeriodValue: "restrictedPeriodValue",
    restrictedPeriodTypeFrequency: "restrictedPeriodTypeFrequency",
    closureDate: "closureDate",
    precision: "precision",
    postingRulesForSells: "postingRulesForSells",
    postingRulesForBuys: "postingRulesForBuys",
    value: "value",
    riskType: "riskType",
    is100PercAllocated: "is100PercAllocated",
    isReallocationAllowed: "isReallocationAllowed",
    isRebalanceAllowed: "isRebalanceAllowed",
    applicableInvestments: "applicableInvestments",
    percentageElections: "percentageElections",
    isPeriodicRebalancing: "isPeriodicRebalancing",
    effectiveDate: "effectiveDate",
    rebalancingFrequency: "rebalancingFrequency",
    marketTimingRule: "marketTimingRule",
    //Model Portfolio Frequency Variables
    excludeSaturday: "excludeSaturday",
    excludeSunday: "excludeSunday",
    startDay: "startDay",
    biWeeklyStartDate: "biWeeklyStartDate",
    firstBeginDay: "firstBeginDay",
    secondBeginDay: "secondBeginDay",
    startDate: "startDate",
    quarterlyStartMonth: "quarterlyStartMonth",
    halfYearlyStartMonth: "halfYearlyStartMonth",
    annuallyStartDate: "annuallyStartDate",
    annuallyStartMonth: "annuallyStartMonth",

    //PerformanceResults
    asOfDate: "asOfDate",
    current: "current",
    ytd: "ytd",
    fromInception: "fromInception",
    threeMonths: "threeMonths",
    oneYear: "oneYear",
    threeYears: "threeYears",
    fiveYears: "fiveYears",
    tenYears: "tenYears",
    //Redemption Fees
    investmentSubjectToRedemptionFee: "investmentSubjectToRedemptionFee",
    sellTransactionsSubjectToRedemptionFees:
      "sellTransactionsSubjectToRedemptionFees",
    buyTransactionsSubjectToHoldingPeriod:
      "buyTransactionsSubjectToHoldingPeriod",
    holdingPeriod: "holdingPeriod",
    isTieredFees: "isTieredFees",
    holdingPeriodDays: "holdingPeriodDays",
    redemptionFee: "redemptionFee",
    effectiveStartDate: "effectiveStartDate",
    effectiveStartTime: "effectiveStartTime",
    effectiveEndDate: "effectiveEndDate",
    effectiveEndTime: "effectiveEndTime",
    holdingPeriodTieredFees: "holdingPeriodTieredFees",
    //Market Timing rules Parameters
    applyMarketTiming: "applyMarketTiming",
    roadTripOccuranceDefinition: "roadTripOccuranceDefinition",
    excludeDollor: "excludeDollor",
    roadTripOccurance: "roadTripOccurance",
    daysBetweenTransfer: "daysBetweenTransfer",
    failedRuleResult: "failedRuleResult",
    daysToBlockFutureTransfers: "daysToBlockFutureTransfers",
    // History
    fromDate: "fromDate",
    toDate: "toDate",
  },
  [manageRkaasFormNames.ADD_CUSTODIAN]: {
    custodianName: "cusodianName",
    custodianID: "custodianID",
    custodianEmail: "custodianEmail",
    custodianPhoneNumber: "custodianPhoneNumber",
    bankAccountNumber: "bankAccountNumber",
    bankName: "bankName",
    ABARoutingNumber: "ABARoutingNumber",
    bankAccountType: "bankAccountType",
    bankAccountStatus: "bankAccountStatus",
    planName: "planName",
    planId: "planId",
    custodianAccountNumber: "custodianAccountNumber",
    description: "description",
    cutOffTime: "cutOffTime",
    clearanceTime: "clearanceTime",
  },
};

export const INVESTMENT_RECORDS_TO_FETCH = 20;
